import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../types/commonTypes";
import adminApi from "../api/adminApi";

interface AdminState {
  loadState: LoadState;
  result?: any;
  error?: string;
}

const initialState: AdminState = {
  loadState: LoadState.INIT,
};

export const adminSlice = createSlice({
  name: "AdminState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(adminApi.endpoints.syncCognitoUsers.matchPending, (state) => {
        state.loadState = LoadState.LOADING;
      })
      .addMatcher(
        adminApi.endpoints.syncCognitoUsers.matchFulfilled,
        (state, { payload }) => {
          state.loadState = LoadState.LOADED;
          state.result = payload;
        }
      )
      .addMatcher(
        adminApi.endpoints.syncCognitoUsers.matchRejected,
        (state) => {
          state.loadState = LoadState.ERROR;
        }
      );
  },
});

export default adminSlice.reducer;
